// extracted by mini-css-extract-plugin
export var previewContainer = "_sj-0";